(() => {
  const arrow = /[↗→➜➔]/g;
  const clean = root => {
    const links = [...(root.matches?.('a') ? [root] : []), ...root.querySelectorAll('a')];
    links.forEach(link => {
      if (link.closest('[role="navigation"],.swiper-button-next,.swiper-button-prev') || link.matches('[aria-label*="slide"],[aria-label*="Next"],[aria-label*="Previous"]')) return;
      if (!link.textContent.replace(/[↗→➜➔\s]/g, '').trim()) return;
      link.querySelectorAll('span,i').forEach(el => {
        if (/^[↗→➜➔\s]+$/.test(el.textContent) && /[↗→➜➔]/.test(el.textContent)) el.classList.add('rcl-decoration-hidden');
      });
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (!node.parentElement.closest('script,style,.rcl-decoration-hidden') && /[↗→➜➔]/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(arrow, '').trimEnd();
      });
    });
  };
  clean(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && !node.matches('script,style')) clean(node);
    }));
  }).observe(document.body, {childList:true, subtree:true});
})();